import React from 'react'

/* 
  used in
  #1 /paybill ==> Pay page from menu ==> ==> smart pay card section
*/
export default function SmartPayCard() {
    return (
            <div class="white_card dashboard_card mt-3">
                <div class="flex_grp_between ">
                    <div class="balance_section_info w-100">
                        <label className='shimmerBG shimmer-text-sm w-50'></label>
                        <p className='shimmerBG shimmer-text-xs w-50'></p>
                    </div>
                    <div class="balance_section_action">
                        <button
                            class="custom_btn custom_btn_sm custom_btn_primary shimmerBG shimmer-button-md"
                        >
                        </button>
                    </div>
                </div>
            </div>
    )
}